import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "data-section-header" }
const _hoisted_2 = { class: "data-section-content" }

import { computed, inject, onMounted, onUnmounted, watch } from 'vue'
import InfoLabel from '@/design-system/molecules/InfoLabel.vue'
import { sharedDataKey } from '../../types'
import DashboardMissingFilter from '../components/DashboardMissingFilter.vue'
import DashboardLoading from './DashboardLoading.vue'
import { useDataSources } from '@/composables/useDataSources'
import DataSourceFetcher from './DataSourceFetcher.vue'
import DashboardMissingData from './DashboardMissingData.vue'
import { FetchType } from '@/fetches'
import FeatureChildren from '@/components/FeatureChildren.vue'
import { DataSource } from './data-section-types'
import { EntityLevel, useEntityLevel } from '@/composables/useEntityLevel'
import { storeToRefs } from 'pinia'
import { useInformation } from '@/pinia/information'
import useColoredEntities from '@/composables/useColoredEntities'

type Props = {
  isLoading: boolean
  isMissingData: boolean
  title: string
  info?: string
  informationFetch?: FetchType
  dataSources?: DataSource[]
  enabledEntityLevels?: EntityLevel[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardDataSectionFlat',
  props: {
    isLoading: { type: Boolean },
    isMissingData: { type: Boolean },
    title: {},
    info: { default: undefined },
    informationFetch: { default: 'fetch.information' },
    dataSources: { default: undefined },
    enabledEntityLevels: { default: () => ['COMPLEX', 'REAL_ESTATE', 'CONSTRUCTION', 'LEVEL', 'FLOOR', 'SPACE'] }
  },
  setup(__props: any) {

const props = __props

const { setDataSource } = useDataSources()
const coloredEntities = useColoredEntities()
const information = useInformation()

const { entityLevel } = storeToRefs(useEntityLevel())

const sharedData = inject(sharedDataKey)

const fullscreen = computed<boolean>(() => sharedData?.fullscreen ?? false)

const fetchDataSources = computed<Record<FetchType, DataSource<'fetch'>[]> | undefined>(() =>
  (
    props.dataSources?.filter((dataSource) => dataSource.type === 'fetch') as
      | DataSource<'fetch'>[]
      | undefined
  )?.reduce((acc, dataSource) => {
    if (!acc[dataSource.fetch]) {
      acc[dataSource.fetch] = []
    }
    acc[dataSource.fetch].push(dataSource)
    return acc
  }, {} as Record<string, DataSource<'fetch'>[]>)
)

watch(
  () => props.dataSources,
  (dataSources) => {
    if (dataSources) {
      dataSources.forEach((dataSource) => {
        if (dataSource.type === 'value') {
          setDataSource({
            id: dataSource.id,
            data: dataSource.value,
            error: false,
            isLoading: false
          })
        }
      })
    }
  },
  { immediate: true }
)

onMounted(() => {
  information.setFetchId(props.informationFetch)
})

onUnmounted(() => {
  coloredEntities.reset(true)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (fetchDataSources.value)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(Object.entries(fetchDataSources.value), ([fetch, ds]) => {
          return (_openBlock(), _createBlock(DataSourceFetcher, {
            key: fetch + ds.map((d) => d.id).join(''),
            fetch: (fetch as FetchType),
            dataSources: ds
          }, null, 8, ["fetch", "dataSources"]))
        }), 128))
      : _createCommentVNode("", true),
    (!_ctx.enabledEntityLevels.includes(_unref(entityLevel)))
      ? (_openBlock(), _createBlock(DashboardMissingFilter, { key: 1 }))
      : (_ctx.isLoading)
        ? (_openBlock(), _createBlock(DashboardLoading, { key: 2 }))
        : (_ctx.isMissingData)
          ? (_openBlock(), _createBlock(DashboardMissingData, { key: 3 }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
              _createElementVNode("section", _hoisted_1, [
                _createVNode(InfoLabel, {
                  title: _ctx.title,
                  info: _ctx.info,
                  size: 'mediumBold',
                  fullscreen: fullscreen.value
                }, null, 8, ["title", "info", "fullscreen"])
              ]),
              _createElementVNode("section", _hoisted_2, [
                _createVNode(FeatureChildren, { feature: "home/*/*/*/data/*" })
              ])
            ], 64))
  ], 64))
}
}

})